export default "__VITE_ASSET__DrTQpCXU__"